import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { injectIntl } from 'react-intl';

import styles from './AnalyzerFilterCategory.styles';

class AnalyzerFilterCategory extends Component {
  constructor(props) {
    super(props);

    this.handleOnCategoryClick = this.handleOnCategoryClick.bind(this);

    this.state = { expanded: props.category.expanded || false };
  }

  componentDidMount() {
    const { onRef } = this.props;
    if (onRef) {
      onRef(this, this.props.category.title);
    }
  }

  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) {
      onRef(undefined, this.props.category.title);
    }
  }

  toggleCategory(expand) {
    this.setState({ expanded: expand });
  }

  handleOnCategoryClick() {
    const {
      category: { entityType },
      handleAddNewEntity,
    } = this.props;

    if (entityType !== 'bool_text_search' && entityType !== 'folder') {
      this.setState((prevState) => ({ expanded: !prevState.expanded }));
    } else {
      const newEntity = this.generateEntityObject(entityType);
      handleAddNewEntity(entityType, newEntity);
    }
  }

  handleOnPinClick(fieldId) {
    this.props.handleFilterOptionsChange(fieldId);
  }

  generateEntityObject(type, filter) {
    const { intl } = this.props;

    const searchWordsContainOptions = [
      {
        value: 'contains',
        label: intl.formatMessage({
          id: 'AnalyzerFilterCategory.containsOption',
          defaultMessage: 'contains',
          description: 'Search contains option label',
        }),
      },
      {
        value: 'does_not_contain',
        label: intl.formatMessage({
          id: 'AnalyzerFilterCategory.doesNotContainOption',
          defaultMessage: 'does not contain',
          description: 'Search does not contain option label',
        }),
      },
    ];
    const searchWordsScopeOptions = [
      {
        value: 'all_of_these_words',
        label: intl.formatMessage({
          id: 'AnalyzerFilterCategory.allOfTheseWordsOption',
          defaultMessage: 'all of these words',
          description: 'Search scope all words option label',
        }),
      },
      {
        value: 'any_of_these_words',
        label: intl.formatMessage({
          id: 'AnalyzerFilterCategory.anyOfTheseWordsOption',
          defaultMessage: 'any of these words',
          description: 'Search scope any words option label',
        }),
      },
      {
        value: 'exact_phrase',
        label: intl.formatMessage({
          id: 'AnalyzerFilterCategory.exactPhraseOption',
          defaultMessage: 'exact phrase',
          description: 'Search scope exact phrase option label',
        }),
      },
    ];

    switch (type) {
      case 'provision':
        return {
          entity: 'provision',
          provision: filter,
          contains: searchWordsContainOptions[0],
          text_search: [],
        };
      case 'text_search':
        return {
          entity: 'text_search',
          area: filter,
          contains: searchWordsContainOptions[0],
          scope: searchWordsScopeOptions[0],
          text: '',
        };
      case 'bool_text_search':
        return {
          entity: 'bool_text_search',
          query: '',
        };
      case 'folder':
        return {
          entity: 'folder',
          folder_ids: [],
        };
      default:
        return filter;
    }
  }

  handleOnFilterClick(filter) {
    const {
      category: { entityType },
      handleAddNewEntity,
    } = this.props;

    const newEntity = this.generateEntityObject(entityType, filter);
    handleAddNewEntity(entityType || 'field', newEntity);
  }

  renderCategoryFields() {
    const { classes, category, noPin, intl } = this.props;

    return (
      <div className={classes.categoryFields}>
        {category.fields.map((field) => {
          const dataForValue = `pin-icon_${field.id}`;

          const filterName = field.label || field;

          return (
            <div
              className={classes.categoryField}
              key={`category-field-${filterName}`}
            >
              <button onClick={() => this.handleOnFilterClick(field)}>
                {filterName}
              </button>
              {!noPin && (
                <IconButton
                  id={dataForValue}
                  text={intl.formatMessage(
                    {
                      id: 'AnalyzerFilterCategory.pinButtonText',
                      defaultMessage: 'pin {filterName}',
                      description:
                        'Pin button accessibility text. Example: filterName = "Contract Type"',
                    },
                    { filterName },
                  )}
                  onClick={() => this.handleOnPinClick(field.id)}
                  icon={field.is_pinned ? 'push-pin-filled' : 'push-pin'}
                  tooltip={
                    field.is_pinned
                      ? intl.formatMessage({
                          id: 'AnalyzerFilterCategory.unpinTooltip',
                          defaultMessage: 'Unpin',
                          description: 'Unpin button tooltip',
                        })
                      : intl.formatMessage({
                          id: 'AnalyzerFilterCategory.pinTooltip',
                          defaultMessage: 'Pin',
                          description: 'Pin button tooltip',
                        })
                  }
                  size="s"
                />
              )}
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { classes, category } = this.props;
    const { expanded } = this.state;

    return (
      <div
        id={`analyzer-filter-${category.title.replace(/\s/gi, '-')}`}
        className={classes.filterCategory}
      >
        <button
          aria-expanded={expanded}
          className={
            expanded
              ? classes.filterCategoryTitleWrapperExpanded
              : classes.filterCategoryTitleWrapper
          }
          onClick={this.handleOnCategoryClick}
        >
          <span>{category.title}</span>
          {!!category.fields.length &&
            (expanded ? (
              <Icon icon="chevron-up" />
            ) : (
              <Icon icon="chevron-down" />
            ))}
        </button>
        {expanded && this.renderCategoryFields()}
      </div>
    );
  }
}

AnalyzerFilterCategory.propTypes = {
  category: PropTypes.shape({
    title: PropTypes.string,
    fields: PropTypes.array,
    entityType: PropTypes.string,
  }),
  onRef: PropTypes.func,
  handleFilterOptionsChange: PropTypes.func,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(injectSheet(styles)(AnalyzerFilterCategory));
